module.exports = __webpack_public_path__ + "img/exit.fd01708c.svg";